import { translations } from "i18n";
import { useState } from "react";
import cn from "classnames";
import { isWindows } from "react-device-detect";

import Popup from "reactjs-popup";
import "reactjs-popup/dist/index.css";

import styles from "./style.module.scss";
import iconMore from "images/Icon.png";
import iconDelete from "images/i-delete.png";
import iconPen from "images/i-pen.svg";
import iconConnected from "images/i-tick-connected.svg";
import iconDisconnected from "images/i-tick-disconnected.svg";
import { useConnectedDevices } from "hooks/ConnectedDevicesHook";
import * as ConnectionState from "lib/devices/wrappers/DeviceStates";
import { getDeviceDisplayName } from "lib/devices/connect";
import BatteryIcon from "components/BatteryIcon";
import RenameDeviceModal from "../RenameDeviceModal";

const DeviceItem = ({ device, index, connectionState, batteryPercent }) => {
  const { deleteDevice, disconnect, reconnectDevice, testDevice } =
    useConnectedDevices();
  const [isModalVisible, setIsModalVisible] = useState("");

  const connectLabel = device.manuallyDisconnected
    ? translations("ToysPage.Reconnect")
    : translations("ToysPage.Connect");

  const connected = connectionState === ConnectionState.CONNECTED;
  let stateName = translations("ToysPage.Disconnected");
  switch (connectionState) {
    case ConnectionState.CONNECTING:
      stateName = translations("ToysPage.Connecting");
      break;
    case ConnectionState.CONNECTED:
      stateName = translations("ToysPage.Connected");
      break;
    case ConnectionState.DISCONNECTING:
      stateName = translations("ToysPage.Disconnecting");
      break;
    case ConnectionState.DISCONNECTED:
    case ConnectionState.MANUALLY_DISCONNECTED:
      stateName = translations("ToysPage.Disconnected");
      break;
    default:
      break;
  }

  return (
    <div className={styles.deviceWrapper}>
      <Popup
        trigger={(open) => (
          <img
            src={iconMore}
            alt="more"
            className={styles.iconMore}
            onClick={() => deleteDevice(index)}
          />
        )}
        position="bottom right"
        closeOnDocumentClick
      >
        <div
          role="button"
          onClick={() => deleteDevice(index)}
          className={styles.menuItemBtn}
        >
          <img src={iconDelete} width={17} height={18} alt="Delete this toy" />
          <span>{translations("ToysPage.DeleteThisToy")}</span>
        </div>

        {isWindows &&
        connectionState === ConnectionState.CONNECTED &&
        device?.wrapper?.setDeviceName ? (
          <div
            role="button"
            onClick={() => setIsModalVisible(true)}
            className={styles.menuItemBtn}
          >
            <img src={iconPen} width={17} height={18} alt="Rename this toy" />
            <span>{translations("ToysPage.RenameTheToy")}</span>
          </div>
        ) : null}
      </Popup>
      <div className={styles.deviceContainer}>
        <img src={device.image} alt="device" className={styles.deviceImg} />
        <div className={styles.deviceContent}>
          <div className={styles.titleContainer}>
            <div className={styles.deviceName}>
              {getDeviceDisplayName(device.name)}
            </div>
          </div>
          {batteryPercent && (
            <div className={styles.devicePropertyContainer}>
              <div className={styles.property}>
                {translations("ToysPage.Battery")}
              </div>
              <div className={styles.value}>{batteryPercent}%</div>
              <BatteryIcon percent={batteryPercent} />
            </div>
          )}
          <div className={styles.devicePropertyContainer}>
            <div className={styles.property}>
              {translations("ToysPage.Status")}
            </div>
            <div className={styles.deviceStatusContainer}>
              <div
                className={cn(
                  styles.deviceStatusValue,
                  connected && styles.connectedStatus
                )}
              >
                {stateName}
              </div>
              <img
                src={connected ? iconConnected : iconDisconnected}
                alt="more"
                className={styles.iconStatus}
              />
            </div>
          </div>

          <div className={styles.devicePropertyContainer}>
            <div className={styles.property}>
              {translations("ToysPage.Brand")}
            </div>
            <div className={styles.value}>{device.company}</div>
          </div>
          <div className={styles.buttonsContainer}>
            {connectionState === ConnectionState.CONNECTED ? (
              <>
                <button
                  className={cn(styles.btn, styles.primaryBtn)}
                  onClick={() => testDevice(index)}
                >
                  {translations("ToysPage.Test")}
                </button>
                <button
                  className={cn(styles.secondaryBtn, styles.btn)}
                  onClick={() => {
                    disconnect(index);
                  }}
                >
                  {translations("ToysPage.Disconnect")}
                </button>
              </>
            ) : null}
            {connectionState === ConnectionState.DISCONNECTED ? (
              <button
                className={cn(styles.btn, styles.primaryBtn)}
                onClick={() => reconnectDevice(index)}
              >
                {translations("ToysPage.Connect")}
              </button>
            ) : null}
          </div>
        </div>
      </div>

      <RenameDeviceModal
        device={device}
        connectionState={connectionState}
        isModalVisible={isModalVisible}
        setIsModalVisible={setIsModalVisible}
      />
    </div>
  );
};

export default DeviceItem;
